import LogoImage from "assets/images/logo.png";
import { Box, Button, Dialog } from "components/Mui/index";
import ReviewForm from "containers/ReviewForm/ReviewForm";
import withModals from "hoc/withModals/withModals";
import React from "react";
import { useTranslation } from "react-i18next";
import { getIsLoggedIn } from "utility/helpers/authHelper";
import { REVIEWS_MODAL } from "utility/modals/constants.jsx";
import { isArabic } from "utils/utils";
import "./Footer.scss";

const Footer = (props) => {
  const { toggleReviewModal, modals } = props;
  const { t } = useTranslation();

  const handleReview = async () => {
    toggleReviewModal();
  };
  return (
    <>
      <Box className="footer text-center py-4 shadow-sm">
        <div
          className={` 
        ${
          getIsLoggedIn() && (isArabic() ? "description-ar" : "description-en")
        } description`}
        >
          <strong>{t("footer.text")}</strong>
          <div className="d-flex justify-content-center mt-3 align-items-center">
            <img src={LogoImage} alt="PSC" className="logo me-2 mt-1" />
          </div>
          {getIsLoggedIn() && (
            <Button onClick={() => handleReview()} className="fs-5">
              {t("header.review")}
            </Button>
          )}
        </div>
      </Box>
      <Dialog
        className="event-attendees-details-dialog"
        mainTitle={t("header.review")}
        open={modals[REVIEWS_MODAL]}
        toggle={toggleReviewModal}
      >
        <ReviewForm toggleReviewModal={toggleReviewModal}></ReviewForm>
      </Dialog>
    </>
  );
};

const modalsProps = {
  toggleReviewModal: REVIEWS_MODAL,
};

export default withModals(Footer, modalsProps);
